// 基地址
const baseUrl = 'http://192.168.50.13:8119'

// * 首页 - 设备信息
const instantLinkList = [
  {
    id: '3',
    text: '接入设备',
    img: require('@/assets/images/home/device.png'),
    path: {
      name: 'content',
      params: {
        contentId: '3'
      }
    }
  },
  {
    id: '6',
    text: '在线设备',
    img: require('@/assets/images/home/online_device.png'),
    path: {
      name: 'content',
      params: {
        contentId: '6'
      }
    }
  }
]

//* 告警统计
const fieldList = [
  {
    venueId: 202,
    venueName: '鼠患',
    keyword: '鼠患',
    venueType: 0,
    status: 0,
    thumb: require('@/assets/images/home/mouse.png')
  },
  {
    venueName: '厨师服',
    keyword: '厨师服',
    thumb: require('@/assets/images/home/cloth.png'),
    venueId: 212,
    venueType: 1,
    status: 0
  },
  {
    venueName: '抽烟',
    keyword: '抽烟',
    thumb: require('@/assets/images/home/smoke.png'),
    venueId: 201,
    venueType: 0,
    status: 0
  },
  {
    venueName: '厨师帽',
    keyword: '厨师帽',
    thumb: require('@/assets/images/home/hat.png'),
    venueId: 203,
    venueType: 1,
    status: 0
  }
]

export default {
  baseUrl, // 基地址
  instantLinkList, // 设备信息
  fieldList
}
